<div class="wrapper">
  <app-card-equipping
    [isLoading]="isLoadingStats > 0"
    [hasPerimeter]="(hasPerimeter$ | async) === true"
    [isAvailableForSelectedTecho]="availableTechnos.includes((techno$ | async) ?? '')"
    [equippingStats]="stats?.equipping"
    [equippingLastModified]="stats?.last_modified"
    class="equipping"
  ></app-card-equipping>
  <app-card-remote-reading
    [isLoading]="isLoadingStats > 0"
    [hasPerimeter]="(hasPerimeter$ | async) === true"
    [isAvailableForSelectedTecho]="availableTechnos.includes((techno$ | async) ?? '')"
    [remoteReadingStats]="stats?.remote_reading"
    [remoteReadingStatsLastModified]="stats?.last_modified"
    [equippingStats]="stats?.equipping"
    class="remote-reading"
  ></app-card-remote-reading>
</div>
